import { render, staticRenderFns } from "./FrameBed.vue?vue&type=template&id=6dce294d&scoped=true"
import script from "./FrameBed.vue?vue&type=script&lang=js"
export * from "./FrameBed.vue?vue&type=script&lang=js"
import style0 from "./FrameBed.vue?vue&type=style&index=0&id=6dce294d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dce294d",
  null
  
)

export default component.exports